import { translateFn } from '../../utils/translator.helper';

export enum CategoryTypes {
  UNKNOWN = 0,
  TAMPERING_TOOl = 1,
  HACK_TOOl = 2,
  REMOTE_TOOL = 3,
  MINER = 4,
  LOL_BIN = 5,
}

export enum CategoryDictionary {
  TAMPERING_TOOl = 'TamperingTool',
  HACK_TOOl = 'HackTool',
  REMOTE_TOOL = 'RemoteTool',
  MINER = 'Miner',
  LOL_BIN = 'Lolbin',
}

export enum ActionTakenTypes {
  ACTION_NEEDED = 0,
  APPLIED = 1,
  PARTIALLY_APPLIED = 2,
}

export function getPhasrCategoryDictionaryToPrefferedName(): Record<CategoryDictionary, string> {
  return {
    [CategoryDictionary.TAMPERING_TOOl]: translateFn('Tampering tools'),
    [CategoryDictionary.HACK_TOOl]: translateFn('Piracy tools'),
    [CategoryDictionary.REMOTE_TOOL]: translateFn('Remote admin tools'),
    [CategoryDictionary.MINER]: translateFn('Crypto miners'),
    [CategoryDictionary.LOL_BIN]: translateFn('Living off the land binaries'),
  };
}

export function getPhasrCategoryTypesName(): { value: CategoryTypes; label: string }[] {
  return [
    {value: CategoryTypes.LOL_BIN, label: translateFn('Living off the land binaries')},
    {value: CategoryTypes.REMOTE_TOOL, label: translateFn('Remote admin tools')},
    {value: CategoryTypes.TAMPERING_TOOl, label: translateFn('Tampering tools')},
    {value: CategoryTypes.HACK_TOOl, label: translateFn('Piracy tools')},
    {value: CategoryTypes.MINER, label: translateFn('Crypto miners')},
  ];
}

export function getPhasrActionTakenTypesName() {
  return [
    {value: ActionTakenTypes.ACTION_NEEDED, label: translateFn('Action needed')},
    {value: ActionTakenTypes.APPLIED, label: translateFn('Applied')},
    {value: ActionTakenTypes.PARTIALLY_APPLIED, label: translateFn('Partially applied')},
  ];
}

export interface PhasrDictionaryEntry {
  category: string;
  rule_description: string;
  rule_recommendation: string;
  rule_name: string;
  ruleId: string;
  rule_mitigation: string;
  rule_allow_mitigation: string;
  rule_allow_name: string;
}

export const ERROR_CODE_NO_PROFILES_UPDATED = 3430;

export enum PhasrEvents {
  SELECTED_PROFILES_CHANGED = 'selected-profiles-changed'
}
